"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this obviously shouldn't be used for anything secure, really it's just a
// simple check you can use to decide whether to show an internal vs external
// link
exports.default = (session) => {
    var _a, _b;
    return ((_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.email) && /@amazon\.[a-z]{2,}$/.test((_b = session === null || session === void 0 ? void 0 : session.user) === null || _b === void 0 ? void 0 : _b.email) ? true : false;
};
//# sourceMappingURL=isInternalUser.js.map